import React, { FC } from "react";
import RecentCustomersWidget from "./RecentCustomersWidget";
import ActiveSubscriptionsWidget from "./ActiveSubscriptionsWidget";
import RecentPaymentsWidget from "./RecentPaymentsWidget";
import DashboardStore from "../DashboardStore";
import ActivityWidget from "./ActivityWidget";
import { ActivityWrapper } from "./DashboardMain.styles";
import NewOrdersWidget from "./NewOrdersWidget";
import ActivityGraphWidget from "./ActivityGraphWidget";
import { observer } from "mobx-react";
import ItemBreakDownWidget from "./ItemBreakDownWidget";
import FundingWidget from "./FundingWidget";
import {
  DashboardTopBar,
  DashboardTopRightSide,
  ItemContentArea,
} from "../../../shared/components";
import { FlexContainer } from "@mindmemobile/mm-shared-global";
import { MainOuterCard } from "../../../shared/styles";
import { ItemsStore, RolesAndPermissionStore } from "../../../shared/store";
import { MerchantAccount } from "../../../shared/models";
import { AuthService } from "../../../shared/services";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

type IProps = {
  dashboardStore: DashboardStore;
  itemStore: ItemsStore;
  merchantAccounts: MerchantAccount[];
  merchantAccountId: string;
  onChangeMerchantAccount: (merchantAccountId: string) => void;
  isMerchantAccountLoading: boolean;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
};
const DashboardMain: FC<IProps> = ({
  dashboardStore,
  itemStore,
  merchantAccounts,
  merchantAccountId,
  onChangeMerchantAccount,
  isMerchantAccountLoading,
  merchantAccountStore,
  rolesAndPermissionStore,
}) => {
  function renderDetails(node: React.ReactNode, showItemRightContent = true) {
    const content = showItemRightContent ? (
      <DashboardTopRightSide
        showMerchantAccount={true}
        merchantAccountId={merchantAccountId}
        merchantAccounts={merchantAccounts}
        itemStore={itemStore}
        onChangeMerchantAccount={(merchantAccountId: string) => {
          onChangeMerchantAccount(merchantAccountId);
        }}
        showMerchantPortalButton={true}
        showSearchInput={false}
      />
    ) : (
      <></>
    );
    return (
      <>
        <DashboardTopBar
          showSearchInput={true}
          showMerchantAccountNotificationBar={
            merchantAccounts.length === 0 && !isMerchantAccountLoading
          }
          showMerchantAccount={true}
          merchantAccountId={merchantAccountId}
          merchantAccounts={merchantAccounts}
          itemStore={itemStore}
          onChangeMerchantAccount={(merchantAccountId: string) => {
            onChangeMerchantAccount(merchantAccountId);
          }}
          rightContent={<>{content}</>}
          merchantAccountStore={merchantAccountStore}
          rolesAndPermissionStore={rolesAndPermissionStore}
        />
        {AuthService.hasAccount && (
          <ItemContentArea
            node={node}
            itemStore={itemStore}
            showMerchantAccountNotificationBar={merchantAccountStore.hasNotificationBar()}
          />
        )}
      </>
    );
  }

  //if (!merchantAccountId) return <>{new Loader(true).loaderComponent}</>;
  return renderDetails(
    <>
      <ActivityWrapper>
        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard width="50%" className="main-card-min-width">
              <ActivityWidget
                dashboardStore={dashboardStore}
                merchantAccountId={merchantAccountId}
              />
            </MainOuterCard>
            <MainOuterCard width="50%">
              <FundingWidget
                dashboardStore={dashboardStore}
                merchantAccountId={merchantAccountId}
              />
            </MainOuterCard>
          </FlexContainer>
        </div>
        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard
              width="100% !important"
              height="550px !important"
              className="db-min-height"
            >
              <ActivityGraphWidget
                dashboardStore={dashboardStore}
                merchantAccountId={merchantAccountId}
              />
            </MainOuterCard>
          </FlexContainer>
        </div>

        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard>
              <NewOrdersWidget
                dashboardStore={dashboardStore}
                merchantAccountId={merchantAccountId}
              />{" "}
            </MainOuterCard>
            <MainOuterCard>
              <ActiveSubscriptionsWidget
                merchantAccountId={merchantAccountId}
                dashboardStore={dashboardStore}
              />
            </MainOuterCard>
          </FlexContainer>
        </div>
        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard>
              <RecentPaymentsWidget
                merchantAccountId={merchantAccountId}
                dashboardStore={dashboardStore}
              />
            </MainOuterCard>
            <MainOuterCard width="340px !important">
              <ItemBreakDownWidget dashboardStore={dashboardStore} />
            </MainOuterCard>
          </FlexContainer>
        </div>
        <div>
          <FlexContainer className="db-min-width">
            <MainOuterCard>
              <RecentCustomersWidget dashboardStore={dashboardStore} />
            </MainOuterCard>
          </FlexContainer>
        </div>
      </ActivityWrapper>
    </>
  );
};

export default observer(DashboardMain);
